import {TooltipProps} from "@mui/material";
import {Colors, Tooltip as SharedTooltip} from "@bounce/shared/ui";

const tooltipSx = {
  maxWidth: 340,
  p: 1.5,
  borderRadius: "10px",
  border: `1px solid ${Colors.grey._200}`,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.5,
  color: Colors.grey._800,
};

export const Tooltip = ({slotProps, ...props}: TooltipProps) => {
  const callerTooltip = typeof slotProps?.tooltip === "function" ? undefined : slotProps?.tooltip;
  const callerSx = callerTooltip?.sx;
  return (
    <SharedTooltip
      arrow
      {...props}
      slotProps={{
        ...slotProps,
        tooltip: {
          ...callerTooltip,
          sx: callerSx ? [tooltipSx, ...(Array.isArray(callerSx) ? callerSx : [callerSx])] : tooltipSx,
        },
      }}
    />
  );
};
